import { render, staticRenderFns } from "./AddPumkm.vue?vue&type=template&id=5a148082&scoped=true&"
import script from "./AddPumkm.js?vue&type=script&lang=js&"
export * from "./AddPumkm.js?vue&type=script&lang=js&"
import style0 from "./AddPumkm.vue?vue&type=style&index=0&id=5a148082&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a148082",
  null
  
)

export default component.exports